import { ProductTableCountCell } from './ProductTableCountCell';

export default ProductTableCountCell;